export default "__VITE_ASSET__vPAds52w__";